import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  VerticalMenuDefinition,
  VerticalMenuProps as VerticalMenuCarmiData,
} from '@wix/thunderbolt-components';
import { DefaultCompPlatformProps } from '@wix/editor-elements-types';
import { VerticalMenuProps } from '../VerticalMenu.types';

export const props = withCompInfo<
  VerticalMenuProps,
  VerticalMenuDefinition,
  VerticalMenuCarmiData & DefaultCompPlatformProps
>()([], (_deps, carmiData) => {
  return carmiData;
});

export default createComponentMapperModel({ props });
